var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _circle, _circle2, _path53, _circle3, _circle4, _path54, _circle5, _circle6, _circle7, _path55, _circle8, _circle9, _circle10, _path56, _circle11, _circle12, _circle13, _path57, _circle14, _circle15, _circle16, _path58, _circle17, _circle18, _circle19, _path59, _circle20, _circle21, _circle22, _path60, _circle23, _circle24, _circle25, _circle26, _path61, _path62, _path63, _path64, _path65, _path66, _circle27, _g, _path67, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraditional(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 507,
    viewBox: "0 0 482 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 481,
    height: 506,
    rx: 44.5,
    fill: "black",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 245.856L153.752 207.808",
    stroke: "url(#paint0_linear_112_20)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 245.856L153.752 283.904",
    stroke: "url(#paint1_linear_112_20)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 245.856L153.752 360",
    stroke: "url(#paint2_linear_112_20)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 245.856L153.752 435.44",
    stroke: "url(#paint3_linear_112_20)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 321.952L153.752 360",
    stroke: "url(#paint4_linear_112_20)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 397.392L153.752 435.44",
    stroke: "url(#paint5_linear_112_20)",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 283.904L229.848 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 207.808L229.848 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 207.808L305.288 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M382.04 283.904L328.248 207.808",
    stroke: "url(#paint6_linear_112_20)",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.04 359.344L328.248 207.808",
    stroke: "url(#paint7_linear_112_20)",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 207.808L305.944 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 207.808L305.944 359.344",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 207.808L305.944 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 283.904L305.288 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 283.904L305.944 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 283.904L305.944 359.344",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.496 283.904L305.944 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.904 283.904L382.04 283.904",
    stroke: "url(#paint8_linear_112_20)",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M328.904 283.904L382.04 359.344",
    stroke: "url(#paint9_linear_112_20)",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M328.904 359.344L382.04 359.344",
    stroke: "url(#paint10_linear_112_20)",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M328.904 435.44L381.384 360",
    stroke: "url(#paint11_linear_112_20)",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M328.904 435.44L381.384 283.904",
    stroke: "url(#paint12_linear_112_20)",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M328.904 359.344L381.384 283.904",
    stroke: "url(#paint13_linear_112_20)",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 359.344L305.944 359.344",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 359.344L305.944 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 359.344L305.288 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 359.344L305.944 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 435.44L305.944 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 435.44L305.944 359.344",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 435.44L305.944 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M252.152 435.44L305.944 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 207.808L229.848 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 207.808L229.848 360",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 207.808L229.848 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 283.904H229.848",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 360H229.192",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 360L229.848 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 360L229.848 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 360L229.848 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 435.44L229.848 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 435.44L229.848 359.344",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 435.44L229.848 283.904",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 435.44L229.848 207.808",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 283.904L229.848 360",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 283.904L229.848 435.44",
    stroke: "#9C96F5",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 321.952L153.752 283.904",
    stroke: "url(#paint14_linear_112_20)",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 321.952L153.752 207.808",
    stroke: "url(#paint15_linear_112_20)",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 321.952L153.752 435.44",
    stroke: "url(#paint16_linear_112_20)",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 397.392L153.752 360",
    stroke: "url(#paint17_linear_112_20)",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 397.392L153.752 207.808",
    stroke: "url(#paint18_linear_112_20)",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 397.392L153.752 283.904",
    stroke: "url(#paint19_linear_112_20)",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.808,
    cy: 245.856,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.808,
    cy: 321.952,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.808 411.356C96.1963 411.356 102.116 405.212 102.116 397.72C102.116 390.228 96.1963 384.084 88.808 384.084C81.4197 384.084 75.5 390.228 75.5 397.72C75.5 405.212 81.4197 411.356 88.808 411.356Z",
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.808,
    cy: 245.856,
    r: 10.308,
    stroke: "#ACE6FF",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.808,
    cy: 321.952,
    r: 10.308,
    stroke: "#ACE6FF",
    strokeWidth: 3
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M99.116 397.72C99.116 403.633 94.4625 408.356 88.808 408.356C83.1535 408.356 78.5 403.633 78.5 397.72C78.5 391.807 83.1535 387.084 88.808 387.084C94.4625 387.084 99.116 391.807 99.116 397.72Z",
    stroke: "#ACE6FF",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.904,
    cy: 283.904,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.904,
    cy: 207.808,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.904,
    cy: 360,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M164.904 449.404C172.292 449.404 178.212 443.26 178.212 435.768C178.212 428.276 172.292 422.132 164.904 422.132C157.516 422.132 151.596 428.276 151.596 435.768C151.596 443.26 157.516 449.404 164.904 449.404Z",
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.904,
    cy: 283.904,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.904,
    cy: 207.808,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.904,
    cy: 360,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M175.212 435.768C175.212 441.681 170.559 446.404 164.904 446.404C159.25 446.404 154.596 441.681 154.596 435.768C154.596 429.855 159.25 425.132 164.904 425.132C170.559 425.132 175.212 429.855 175.212 435.768Z",
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 283.904,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 207.808,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 360,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M241 449.404C248.388 449.404 254.308 443.26 254.308 435.768C254.308 428.276 248.388 422.132 241 422.132C233.612 422.132 227.692 428.276 227.692 435.768C227.692 443.26 233.612 449.404 241 449.404Z",
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 283.904,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 207.808,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 360,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M251.308 435.768C251.308 441.681 246.654 446.404 241 446.404C235.345 446.404 230.692 441.681 230.692 435.768C230.692 429.855 235.345 425.132 241 425.132C246.654 425.132 251.308 429.855 251.308 435.768Z",
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.096,
    cy: 283.904,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.096,
    cy: 207.808,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.096,
    cy: 360,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M317.096 449.404C324.484 449.404 330.404 443.26 330.404 435.768C330.404 428.276 324.484 422.132 317.096 422.132C309.708 422.132 303.788 428.276 303.788 435.768C303.788 443.26 309.708 449.404 317.096 449.404Z",
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.096,
    cy: 283.904,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.096,
    cy: 207.808,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.096,
    cy: 360,
    r: 10.308,
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M327.404 435.768C327.404 441.681 322.751 446.404 317.096 446.404C311.442 446.404 306.788 441.681 306.788 435.768C306.788 429.855 311.442 425.132 317.096 425.132C322.751 425.132 327.404 429.855 327.404 435.768Z",
    stroke: "#9C96F5",
    strokeWidth: 3
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.192,
    cy: 283.904,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.192,
    cy: 360,
    r: 13.308,
    stroke: "#0B0B0B",
    strokeWidth: 3
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.192,
    cy: 283.904,
    r: 10.308,
    stroke: "#BFF9B4",
    strokeWidth: 3
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.192,
    cy: 360,
    r: 10.308,
    stroke: "#BFF9B4",
    strokeWidth: 3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3536 245.354C67.5488 245.158 67.5488 244.842 67.3536 244.646L64.1716 241.464C63.9763 241.269 63.6597 241.269 63.4645 241.464C63.2692 241.66 63.2692 241.976 63.4645 242.172L66.2929 245L63.4645 247.828C63.2692 248.024 63.2692 248.34 63.4645 248.536C63.6597 248.731 63.9763 248.731 64.1716 248.536L67.3536 245.354ZM46 245.5L67 245.5L67 244.5L46 244.5L46 245.5Z",
    fill: "#ACE6FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M436.354 284.354C436.549 284.158 436.549 283.842 436.354 283.646L433.172 280.464C432.976 280.269 432.66 280.269 432.464 280.464C432.269 280.66 432.269 280.976 432.464 281.172L435.293 284L432.464 286.828C432.269 287.024 432.269 287.34 432.464 287.536C432.66 287.731 432.976 287.731 433.172 287.536L436.354 284.354ZM415 284.5L436 284.5L436 283.5L415 283.5L415 284.5Z",
    fill: "#BFF9B4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M436.354 360.354C436.549 360.158 436.549 359.842 436.354 359.646L433.172 356.464C432.976 356.269 432.66 356.269 432.464 356.464C432.269 356.66 432.269 356.976 432.464 357.172L435.293 360L432.464 362.828C432.269 363.024 432.269 363.34 432.464 363.536C432.66 363.731 432.976 363.731 433.172 363.536L436.354 360.354ZM415 360.5L436 360.5L436 359.5L415 359.5L415 360.5Z",
    fill: "#BFF9B4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3536 322.354C67.5488 322.158 67.5488 321.842 67.3536 321.646L64.1716 318.464C63.9763 318.269 63.6597 318.269 63.4645 318.464C63.2692 318.66 63.2692 318.976 63.4645 319.172L66.2929 322L63.4645 324.828C63.2692 325.024 63.2692 325.34 63.4645 325.536C63.6597 325.731 63.9763 325.731 64.1716 325.536L67.3536 322.354ZM46 322.5L67 322.5L67 321.5L46 321.5L46 322.5Z",
    fill: "#ACE6FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3536 398.354C67.5488 398.158 67.5488 397.842 67.3536 397.646L64.1716 394.464C63.9763 394.269 63.6597 394.269 63.4645 394.464C63.2692 394.66 63.2692 394.976 63.4645 395.172L66.2929 398L63.4645 400.828C63.2692 401.024 63.2692 401.34 63.4645 401.536C63.6597 401.731 63.9763 401.731 64.1716 401.536L67.3536 398.354ZM46 398.5L67 398.5L67 397.5L46 397.5L46 398.5Z",
    fill: "#ACE6FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M207.669 58.196C206.455 58.196 205.494 57.86 204.785 57.188C204.075 56.5067 203.721 55.536 203.721 54.276V51.924C203.721 50.664 204.075 49.698 204.785 49.026C205.494 48.3447 206.455 48.004 207.669 48.004C208.873 48.004 209.801 48.3353 210.455 48.998C211.117 49.6513 211.449 50.552 211.449 51.7V51.784H209.629V51.644C209.629 51.0653 209.465 50.5893 209.139 50.216C208.821 49.8427 208.331 49.656 207.669 49.656C207.015 49.656 206.502 49.8567 206.129 50.258C205.755 50.6593 205.569 51.2053 205.569 51.896V54.304C205.569 54.9853 205.755 55.5313 206.129 55.942C206.502 56.3433 207.015 56.544 207.669 56.544C208.331 56.544 208.821 56.3573 209.139 55.984C209.465 55.6013 209.629 55.1253 209.629 54.556V54.304H211.449V54.5C211.449 55.648 211.117 56.5533 210.455 57.216C209.801 57.8693 208.873 58.196 207.669 58.196ZM216.174 58.196C215.484 58.196 214.872 58.0513 214.34 57.762C213.818 57.4633 213.407 57.048 213.108 56.516C212.819 55.9747 212.674 55.34 212.674 54.612V54.444C212.674 53.716 212.819 53.086 213.108 52.554C213.398 52.0127 213.804 51.5973 214.326 51.308C214.849 51.0093 215.456 50.86 216.146 50.86C216.828 50.86 217.42 51.014 217.924 51.322C218.428 51.6207 218.82 52.0407 219.1 52.582C219.38 53.114 219.52 53.7347 219.52 54.444V55.046H214.466C214.485 55.522 214.662 55.9093 214.998 56.208C215.334 56.5067 215.745 56.656 216.23 56.656C216.725 56.656 217.089 56.5487 217.322 56.334C217.556 56.1193 217.733 55.8813 217.854 55.62L219.296 56.376C219.166 56.6187 218.974 56.8847 218.722 57.174C218.48 57.454 218.153 57.6967 217.742 57.902C217.332 58.098 216.809 58.196 216.174 58.196ZM214.48 53.73H217.728C217.691 53.3287 217.528 53.0067 217.238 52.764C216.958 52.5213 216.59 52.4 216.132 52.4C215.656 52.4 215.278 52.5213 214.998 52.764C214.718 53.0067 214.546 53.3287 214.48 53.73ZM221.09 58V51.056H222.826V51.966H223.078C223.19 51.7233 223.4 51.4947 223.708 51.28C224.016 51.056 224.483 50.944 225.108 50.944C225.65 50.944 226.121 51.07 226.522 51.322C226.933 51.5647 227.25 51.9053 227.474 52.344C227.698 52.7733 227.81 53.2773 227.81 53.856V58H226.046V53.996C226.046 53.4733 225.916 53.0813 225.654 52.82C225.402 52.5587 225.038 52.428 224.562 52.428C224.021 52.428 223.601 52.61 223.302 52.974C223.004 53.3287 222.854 53.828 222.854 54.472V58H221.09ZM232.186 58C231.729 58 231.355 57.86 231.066 57.58C230.786 57.2907 230.646 56.908 230.646 56.432V52.512H228.91V51.056H230.646V48.9H232.41V51.056H234.314V52.512H232.41V56.124C232.41 56.404 232.541 56.544 232.802 56.544H234.146V58H232.186ZM235.911 58V51.056H237.647V51.84H237.899C238.001 51.56 238.169 51.3547 238.403 51.224C238.645 51.0933 238.925 51.028 239.243 51.028H240.083V52.596H239.215C238.767 52.596 238.398 52.7173 238.109 52.96C237.819 53.1933 237.675 53.5573 237.675 54.052V58H235.911ZM243.453 58.196C242.959 58.196 242.515 58.112 242.123 57.944C241.731 57.7667 241.419 57.5147 241.185 57.188C240.961 56.852 240.849 56.446 240.849 55.97C240.849 55.494 240.961 55.0973 241.185 54.78C241.419 54.4533 241.736 54.2107 242.137 54.052C242.548 53.884 243.015 53.8 243.537 53.8H245.441V53.408C245.441 53.0813 245.339 52.8153 245.133 52.61C244.928 52.3953 244.601 52.288 244.153 52.288C243.715 52.288 243.388 52.3907 243.173 52.596C242.959 52.792 242.819 53.0487 242.753 53.366L241.129 52.82C241.241 52.4653 241.419 52.1433 241.661 51.854C241.913 51.5553 242.245 51.3173 242.655 51.14C243.075 50.9533 243.584 50.86 244.181 50.86C245.096 50.86 245.819 51.0887 246.351 51.546C246.883 52.0033 247.149 52.666 247.149 53.534V56.124C247.149 56.404 247.28 56.544 247.541 56.544H248.101V58H246.925C246.58 58 246.295 57.916 246.071 57.748C245.847 57.58 245.735 57.356 245.735 57.076V57.062H245.469C245.432 57.174 245.348 57.3233 245.217 57.51C245.087 57.6873 244.881 57.846 244.601 57.986C244.321 58.126 243.939 58.196 243.453 58.196ZM243.761 56.768C244.256 56.768 244.657 56.6327 244.965 56.362C245.283 56.082 245.441 55.7133 245.441 55.256V55.116H243.663C243.337 55.116 243.08 55.186 242.893 55.326C242.707 55.466 242.613 55.662 242.613 55.914C242.613 56.166 242.711 56.3713 242.907 56.53C243.103 56.6887 243.388 56.768 243.761 56.768ZM249.391 58V48.2H251.155V58H249.391ZM253.11 58V51.056H254.874V58H253.11ZM253.992 50.244C253.675 50.244 253.404 50.1413 253.18 49.936C252.965 49.7307 252.858 49.46 252.858 49.124C252.858 48.788 252.965 48.5173 253.18 48.312C253.404 48.1067 253.675 48.004 253.992 48.004C254.319 48.004 254.589 48.1067 254.804 48.312C255.019 48.5173 255.126 48.788 255.126 49.124C255.126 49.46 255.019 49.7307 254.804 49.936C254.589 50.1413 254.319 50.244 253.992 50.244ZM256.577 58V55.9L260.385 52.736V52.512H256.717V51.056H262.317V53.156L258.509 56.32V56.544H262.429V58H256.577ZM267.116 58.196C266.425 58.196 265.814 58.0513 265.282 57.762C264.759 57.4633 264.348 57.048 264.05 56.516C263.76 55.9747 263.616 55.34 263.616 54.612V54.444C263.616 53.716 263.76 53.086 264.05 52.554C264.339 52.0127 264.745 51.5973 265.268 51.308C265.79 51.0093 266.397 50.86 267.088 50.86C267.769 50.86 268.362 51.014 268.866 51.322C269.37 51.6207 269.762 52.0407 270.042 52.582C270.322 53.114 270.462 53.7347 270.462 54.444V55.046H265.408C265.426 55.522 265.604 55.9093 265.94 56.208C266.276 56.5067 266.686 56.656 267.172 56.656C267.666 56.656 268.03 56.5487 268.264 56.334C268.497 56.1193 268.674 55.8813 268.796 55.62L270.238 56.376C270.107 56.6187 269.916 56.8847 269.664 57.174C269.421 57.454 269.094 57.6967 268.684 57.902C268.273 58.098 267.75 58.196 267.116 58.196ZM265.422 53.73H268.67C268.632 53.3287 268.469 53.0067 268.18 52.764C267.9 52.5213 267.531 52.4 267.074 52.4C266.598 52.4 266.22 52.5213 265.94 52.764C265.66 53.0067 265.487 53.3287 265.422 53.73ZM274.832 58.196C274.281 58.196 273.763 58.0607 273.278 57.79C272.802 57.51 272.419 57.104 272.13 56.572C271.84 56.04 271.696 55.396 271.696 54.64V54.416C271.696 53.66 271.84 53.016 272.13 52.484C272.419 51.952 272.802 51.5507 273.278 51.28C273.754 51 274.272 50.86 274.832 50.86C275.252 50.86 275.602 50.9113 275.882 51.014C276.171 51.1073 276.404 51.2287 276.582 51.378C276.759 51.5273 276.894 51.686 276.988 51.854H277.24V48.2H279.004V58H277.268V57.16H277.016C276.857 57.4213 276.61 57.6593 276.274 57.874C275.947 58.0887 275.466 58.196 274.832 58.196ZM275.364 56.656C275.905 56.656 276.358 56.4833 276.722 56.138C277.086 55.7833 277.268 55.27 277.268 54.598V54.458C277.268 53.786 277.086 53.2773 276.722 52.932C276.367 52.5773 275.914 52.4 275.364 52.4C274.822 52.4 274.37 52.5773 274.006 52.932C273.642 53.2773 273.46 53.786 273.46 54.458V54.598C273.46 55.27 273.642 55.7833 274.006 56.138C274.37 56.4833 274.822 56.656 275.364 56.656ZM224.218 76.196C223.462 76.196 222.794 76.0607 222.216 75.79C221.637 75.5193 221.184 75.132 220.858 74.628C220.531 74.124 220.368 73.5173 220.368 72.808V72.416H222.188V72.808C222.188 73.396 222.37 73.8393 222.734 74.138C223.098 74.4273 223.592 74.572 224.218 74.572C224.852 74.572 225.324 74.446 225.632 74.194C225.949 73.942 226.108 73.62 226.108 73.228C226.108 72.9573 226.028 72.738 225.87 72.57C225.72 72.402 225.496 72.2667 225.198 72.164C224.908 72.052 224.554 71.9493 224.134 71.856L223.812 71.786C223.14 71.6367 222.561 71.45 222.076 71.226C221.6 70.9927 221.231 70.6893 220.97 70.316C220.718 69.9427 220.592 69.4573 220.592 68.86C220.592 68.2627 220.732 67.754 221.012 67.334C221.301 66.9047 221.702 66.578 222.216 66.354C222.738 66.1207 223.35 66.004 224.05 66.004C224.75 66.004 225.37 66.1253 225.912 66.368C226.462 66.6013 226.892 66.956 227.2 67.432C227.517 67.8987 227.676 68.4867 227.676 69.196V69.616H225.856V69.196C225.856 68.8227 225.781 68.524 225.632 68.3C225.492 68.0667 225.286 67.8987 225.016 67.796C224.745 67.684 224.423 67.628 224.05 67.628C223.49 67.628 223.074 67.7353 222.804 67.95C222.542 68.1553 222.412 68.44 222.412 68.804C222.412 69.0467 222.472 69.252 222.594 69.42C222.724 69.588 222.916 69.728 223.168 69.84C223.42 69.952 223.742 70.05 224.134 70.134L224.456 70.204C225.156 70.3533 225.762 70.5447 226.276 70.778C226.798 71.0113 227.204 71.3193 227.494 71.702C227.783 72.0847 227.928 72.5747 227.928 73.172C227.928 73.7693 227.774 74.2967 227.466 74.754C227.167 75.202 226.738 75.5567 226.178 75.818C225.627 76.07 224.974 76.196 224.218 76.196ZM232.526 76.196C231.835 76.196 231.224 76.0513 230.692 75.762C230.169 75.4633 229.759 75.048 229.46 74.516C229.171 73.9747 229.026 73.34 229.026 72.612V72.444C229.026 71.716 229.171 71.086 229.46 70.554C229.749 70.0127 230.155 69.5973 230.678 69.308C231.201 69.0093 231.807 68.86 232.498 68.86C233.179 68.86 233.772 69.014 234.276 69.322C234.78 69.6207 235.172 70.0407 235.452 70.582C235.732 71.114 235.872 71.7347 235.872 72.444V73.046H230.818C230.837 73.522 231.014 73.9093 231.35 74.208C231.686 74.5067 232.097 74.656 232.582 74.656C233.077 74.656 233.441 74.5487 233.674 74.334C233.907 74.1193 234.085 73.8813 234.206 73.62L235.648 74.376C235.517 74.6187 235.326 74.8847 235.074 75.174C234.831 75.454 234.505 75.6967 234.094 75.902C233.683 76.098 233.161 76.196 232.526 76.196ZM230.832 71.73H234.08C234.043 71.3287 233.879 71.0067 233.59 70.764C233.31 70.5213 232.941 70.4 232.484 70.4C232.008 70.4 231.63 70.5213 231.35 70.764C231.07 71.0067 230.897 71.3287 230.832 71.73ZM237.442 76V69.056H239.178V69.84H239.43C239.533 69.56 239.701 69.3547 239.934 69.224C240.177 69.0933 240.457 69.028 240.774 69.028H241.614V70.596H240.746C240.298 70.596 239.929 70.7173 239.64 70.96C239.351 71.1933 239.206 71.5573 239.206 72.052V76H237.442ZM244.449 76L242.237 69.056H244.113L245.723 74.712H245.975L247.585 69.056H249.461L247.249 76H244.449ZM253.622 76.196C252.931 76.196 252.32 76.0513 251.788 75.762C251.265 75.4633 250.854 75.048 250.556 74.516C250.266 73.9747 250.122 73.34 250.122 72.612V72.444C250.122 71.716 250.266 71.086 250.556 70.554C250.845 70.0127 251.251 69.5973 251.774 69.308C252.296 69.0093 252.903 68.86 253.594 68.86C254.275 68.86 254.868 69.014 255.372 69.322C255.876 69.6207 256.268 70.0407 256.548 70.582C256.828 71.114 256.968 71.7347 256.968 72.444V73.046H251.914C251.932 73.522 252.11 73.9093 252.446 74.208C252.782 74.5067 253.192 74.656 253.678 74.656C254.172 74.656 254.536 74.5487 254.77 74.334C255.003 74.1193 255.18 73.8813 255.302 73.62L256.744 74.376C256.613 74.6187 256.422 74.8847 256.17 75.174C255.927 75.454 255.6 75.6967 255.19 75.902C254.779 76.098 254.256 76.196 253.622 76.196ZM251.928 71.73H255.176C255.138 71.3287 254.975 71.0067 254.686 70.764C254.406 70.5213 254.037 70.4 253.58 70.4C253.104 70.4 252.726 70.5213 252.446 70.764C252.166 71.0067 251.993 71.3287 251.928 71.73ZM258.538 76V69.056H260.274V69.84H260.526C260.628 69.56 260.796 69.3547 261.03 69.224C261.272 69.0933 261.552 69.028 261.87 69.028H262.71V70.596H261.842C261.394 70.596 261.025 70.7173 260.736 70.96C260.446 71.1933 260.302 71.5573 260.302 72.052V76H258.538Z",
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 115,
    r: 27.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.788 122.843V122.593H240.538H228.003C227.579 122.593 227.25 122.264 227.25 121.884V114.647C227.25 114.265 227.574 113.938 228.003 113.938H254.991C255.422 113.938 255.75 114.267 255.75 114.647V121.884C255.75 122.263 255.422 122.593 254.991 122.593H242.556H242.306V122.843V125.257V125.38L242.404 125.455C242.721 125.699 242.922 126.058 242.922 126.461C242.922 127.164 242.319 127.756 241.547 127.756C240.775 127.756 240.171 127.164 240.171 126.461C240.171 126.057 240.369 125.698 240.689 125.456L240.788 125.381V125.257V122.843ZM253.981 121.175H254.231V120.925V115.6V115.35H253.981H229.013H228.763V115.6V120.925V121.175H229.013H253.981Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.089 118.31C252.089 119.073 251.435 119.704 250.613 119.704C249.791 119.704 249.138 119.073 249.138 118.31C249.138 117.547 249.791 116.916 250.613 116.916C251.435 116.916 252.089 117.547 252.089 118.31ZM251.18 118.31C251.18 118.003 250.917 117.764 250.613 117.764C250.309 117.764 250.046 118.003 250.046 118.31C250.046 118.617 250.309 118.856 250.613 118.856C250.918 118.856 251.18 118.617 251.18 118.31Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.981 110.487H254.231V110.237V104.912V104.662H253.981H229.013H228.763V104.912V110.237V110.487H229.013H253.981ZM228.003 103.25H254.991C255.422 103.25 255.75 103.579 255.75 103.959V111.196C255.75 111.575 255.422 111.905 254.991 111.905H228.003C227.579 111.905 227.25 111.576 227.25 111.196V103.959C227.25 103.578 227.579 103.25 228.003 103.25Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.089 107.628C252.089 108.391 251.435 109.022 250.613 109.022C249.791 109.022 249.138 108.391 249.138 107.628C249.138 106.864 249.791 106.233 250.613 106.233C251.435 106.233 252.089 106.864 252.089 107.628ZM251.18 107.628C251.18 107.32 250.918 107.082 250.613 107.082C250.309 107.082 250.046 107.32 250.046 107.628C250.046 107.935 250.309 108.173 250.613 108.173C250.918 108.173 251.18 107.935 251.18 107.628Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.379 125.747H254.797C255.228 125.747 255.556 126.081 255.556 126.456C255.556 126.829 255.23 127.159 254.797 127.159H252.379C251.946 127.159 251.62 126.834 251.62 126.456C251.62 126.076 251.948 125.747 252.379 125.747Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.335 125.747H248.753C249.184 125.747 249.512 126.081 249.512 126.456C249.512 126.829 249.185 127.159 248.753 127.159H246.335C245.902 127.159 245.576 126.834 245.576 126.456C245.576 126.076 245.904 125.747 246.335 125.747Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.253 125.747H236.671C237.094 125.747 237.424 126.08 237.424 126.456C237.424 126.831 237.101 127.159 236.671 127.159H234.253C233.819 127.159 233.494 126.834 233.494 126.456C233.494 126.076 233.821 125.747 234.253 125.747Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.215 125.747H230.626H230.632C231.063 125.747 231.392 126.081 231.392 126.456C231.392 126.829 231.065 127.159 230.632 127.159H228.215C227.781 127.159 227.455 126.834 227.455 126.456C227.455 126.076 227.783 125.747 228.215 125.747Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 0.5
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M241 150L241 175",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_20",
    x1: 100,
    y1: 246,
    x2: 154,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_20",
    x1: 100,
    y1: 246,
    x2: 155,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_112_20",
    x1: 100,
    y1: 245,
    x2: 154,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_112_20",
    x1: 99.9999,
    y1: 246,
    x2: 154,
    y2: 435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_112_20",
    x1: 99,
    y1: 322,
    x2: 154.5,
    y2: 360.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_112_20",
    x1: 100,
    y1: 397,
    x2: 154,
    y2: 435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_112_20",
    x1: 328,
    y1: 208,
    x2: 382,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_112_20",
    x1: 330,
    y1: 213.5,
    x2: 382,
    y2: 359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_112_20",
    x1: 330.5,
    y1: 284,
    x2: 382,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_112_20",
    x1: 330.5,
    y1: 285.5,
    x2: 382,
    y2: 359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_112_20",
    x1: 329,
    y1: 359,
    x2: 382,
    y2: 359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_112_20",
    x1: 329,
    y1: 435,
    x2: 381,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_112_20",
    x1: 329,
    y1: 432,
    x2: 381,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_112_20",
    x1: 330,
    y1: 357.5,
    x2: 381,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_112_20",
    x1: 100,
    y1: 322,
    x2: 154,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_112_20",
    x1: 99.9998,
    y1: 322,
    x2: 154,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_112_20",
    x1: 99.9995,
    y1: 322,
    x2: 154,
    y2: 436.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_112_20",
    x1: 99,
    y1: 398,
    x2: 155,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_112_20",
    x1: 99.9999,
    y1: 397,
    x2: 154,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_112_20",
    x1: 99.9998,
    y1: 397,
    x2: 154,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C96F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white",
    transform: "translate(227 103)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraditional);
export default __webpack_public_path__ + "static/media/Traditional.adc1493b8be3f9a385d92eedce76876a.svg";
export { ForwardRef as ReactComponent };